import { render, staticRenderFns } from "./MeetingSubscriptionPage.vue?vue&type=template&id=bb97bd7e&scoped=true"
import script from "./MeetingSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./MeetingSubscriptionPage.vue?vue&type=script&lang=js"
import style0 from "./MeetingSubscriptionPage.vue?vue&type=style&index=0&id=bb97bd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97bd7e",
  null
  
)

export default component.exports